import { getAnalytics } from 'firebase/analytics'
import { initializeApp } from "firebase/app"
import { getAuth } from "firebase/auth"
import { getFirestore } from "firebase/firestore"
import { getFunctions } from 'firebase/functions'; // connectFunctionsEmulator
import { getStorage } from "firebase/storage"
import { getDatabase } from "firebase/database"

export const config = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

// DEV CREDENTIALS
// Phone number:     Code:
// +1 613-604-3879	111111	
// +880 1723-111581	123456	
// +65 9123 4567	888999	
// +65 9876 5432	898989	
// +880 1734-111591	123456	
// +92 307 2894423	112233	
// +91 96873 67261	232323	
// +65 77778888	777888	
// +65 11112222	111222

export const firebaseApp = initializeApp(config)
export const storage = getStorage(firebaseApp)
export const db = getFirestore(firebaseApp)
export const auth = getAuth(firebaseApp)
export const analytics = getAnalytics(firebaseApp)
export const functions = getFunctions(firebaseApp)
export const realtimeDatabase = getDatabase(firebaseApp)
//connectFunctionsEmulator(functions, "localhost", 5001);